let baseUrl
const href = window.location.href

// 判断是否是本机访问（用于连接本地 IIS）
if (href.indexOf('192.168.2.10') > -1) {
  baseUrl = 'http://192.168.2.10:你的IIS端口号' // 等你装好 IIS 后填写端口号
} else if (href.indexOf('192.168') > -1) {
  // 其他局域网地址，连接测试服务器
  baseUrl = 'http://192.168.1.151:8025'
} else {
  // 外网访问，连接线上服务器
  baseUrl = 'https://api2.miszs.zs-tek.com'
}

export default baseUrl
